/**
 * Constantes Global
 *
 */
export class Global {

  // varivel CONTENT_TYPE
  public static CONTENT_TYPE = 'Content-Type';

  // varivel APPLICATION_TYPE_JSON
  public static APPLICATION_TYPE_JSON = 'application/json; charset=utf-8' 
  ;
}



// WEBPACK FOOTER //
// ./src/app/shared/constantes/global.ts